import { useEffect, useState } from "react";

// true for a few seconds whenever new mail/SMS arrives (event fired by the Dashboard poller); kind: "email" | "sms" | "any"
export function useMailShake(kind = "email") {
  const [on, setOn] = useState(false);
  useEffect(() => {
    let t;
    const f = (e) => {
      if (kind !== "any" && (e.detail?.kind || "email") !== kind) return;
      setOn(false); requestAnimationFrame(() => setOn(true)); clearTimeout(t); t = setTimeout(() => setOn(false), 2600);
    };
    window.addEventListener("aqualux:mail-arrived", f);
    return () => { clearTimeout(t); window.removeEventListener("aqualux:mail-arrived", f); };
  }, [kind]);
  return on;
}

// latest counts broadcast by the Dashboard poller
export function useMailCounts() {
  const [c, setC] = useState({ new: 0, sms: 0 });
  useEffect(() => {
    const f = (e) => setC(e.detail || { new: 0, sms: 0 });
    window.addEventListener("aqualux:mail-counts", f);
    window.dispatchEvent(new Event("aqualux:mail-counts-request"));
    return () => window.removeEventListener("aqualux:mail-counts", f);
  }, []);
  return c;
}
